import React from "react";
import { IRpgBackground } from "../../../models/IRpgBackground";
import BackgroundSelectionCard from "./BackgroundSelectionCard";
import BackgroundDetailsPanel from "./BackgroundDetailsPanel";

interface IBackgroundPanelProps {
    isReadOnly: boolean;
    backgroundList: IRpgBackground[];
    selectedBackground: IRpgBackground | null;
    noneBackground: IRpgBackground;
    onSelectBackground: (bg: IRpgBackground | null) => void;
}

const BackgroundPanel: React.FC<IBackgroundPanelProps> = ({
    isReadOnly,
    backgroundList,
    selectedBackground,
    noneBackground,
    onSelectBackground,
}) => {
    const displayBackground = selectedBackground ?? noneBackground;
    const isNoneSelected = selectedBackground === null;

    const onBackground_Select = (bg: IRpgBackground | null) => {
        if (isReadOnly) {
            return;
        }

        onSelectBackground(bg);
    };

    return (
        <div className="background-tab__bg">
            <div className="background-tab__bg-grid">
                <BackgroundSelectionCard
                    title={noneBackground.Name}
                    description={noneBackground.Description}
                    isSelected={isNoneSelected}
                    disabled={isReadOnly}
                    onClick={() => onBackground_Select(null)}
                />

                {backgroundList.map((background) => {
                    const isSelected = selectedBackground?.Id === background.Id;

                    return (
                        <BackgroundSelectionCard
                            key={background.Id}
                            title={background.Name}
                            description={background.Description}
                            isSelected={isSelected}
                            disabled={isReadOnly}
                            onClick={() => onBackground_Select(background)}
                        />
                    );
                })}
            </div>

            <div className="background-tab__details">
                <div className="background-tab__details-card">
                    <BackgroundDetailsPanel background={displayBackground} />
                </div>
            </div>
        </div>
    );
};

export default BackgroundPanel;
